export default __webpack_public_path__ + "static/media/highlighter.47ae4a2e.png";